import './load-file.scss'

import { InboxOutlined } from '@ant-design/icons'
import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'

import { loadCsv } from './csv-handler'

interface Props {
  headers: string[]
  onLoad: (args: any) => void
  onError: (args: any) => void
}

export const LoadFile = ({ onLoad, onError, headers }: Props) => {
  const [contentMessage, setContentMessage] = useState('Click or drag your file to this area to upload')

  const onDrop = useCallback(
    ([acceptedFile]) => {
      const reader = new FileReader()

      reader.readAsBinaryString(acceptedFile)
      reader.onerror = (error) => onError(error)
      reader.onload = () => loadCsv({ onError, onLoad, headers, setContentMessage, acceptedFile, reader })
    },
    [headers, onError, onLoad],
  )

  const { getRootProps, getInputProps } = useDropzone({ onDrop })

  return (
    <div className="upload-container" {...getRootProps()} data-testid="dropzone">
      <input {...getInputProps()} />
      <div className="instructions">
        <div className="drag-icon">
          <InboxOutlined />
        </div>
        <div className="upload-text">
          <span data-testid="results">{contentMessage}</span>
        </div>
      </div>
    </div>
  )
}
